const LANGUAGE_MAPPING = {
  add: 'Agregar',
  addressParts: {
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Código postal',
  },
  accountDialog: {
    changeEmail: 'Cambiar E-mail',
    changePassword: 'Cambiar la Contraseña',
    confirmNewEmail: 'Confirme nuevo correo electrónico',
    confirmNewPassword: 'Confirmar nueva contraseña',
    currentPassword: 'Contraseña actual',
    emailsMustMatch: 'Los correos electrónicos deben coincidir',
    mustProvidePassword:
      'Debe proporcionar su contraseña actual para actualizar los detalles de su cuenta.',
    newEmail: 'Nuevo correo electrónico',
    passwordsMustMatch: 'Las contraseñas deben coincidir',
  },
  alreadyHaveAccountMessage: '¿Ya tienes una cuenta?',
  alreadyHaveAccountLink:
    '¿Ya tienes una cuenta? <a href="/sign_in">Iniciar sesión</a>',
  annotationPanel: {
    changesSaved: 'Se guardaron los cambios de anotación.',
    requestUnderwayMessage: 'Su solicitud se está procesando.',
    saveError:
      'Error al guardar los cambios de anotación. Por favor, inténtelo de nuevo más tarde.',
  },
  assessments: {
    loading: 'Cargando evaluación...',
    pharmacySelect: {
      addPharmacy: 'Añadir farmacia',
      nearAddress: 'Cerca de la dirección',
      noSearchResults:
        'No se han encontrado resultados. Haga clic en el botón "Atrás" para refinar su búsqueda.',
      pharmacyInfo: 'Información de la farmacia',
      pharmacySearch: 'Búsqueda de farmacias',
      pharmacySearchHelpText:
        'Proporcione un código postal o ciudad y estado para realizar una búsqueda. También puede proporcionar un nombre para ayudar a reducir los resultados.',
      searchResults: 'Resultados de búsqueda de farmacias',
      specialtyLabels: {
        all: 'Todas',
        mailOrder: 'Pedido por correo',
        twentyFourHour: '24 horas',
      },
    },
  },
  cancel: 'Cancelar',
  changeMyPassword: 'Cambiar mi contraseña',
  changeYourPassword: 'Cambia tu contraseña',
  channelsOfCare: {
    chatNow: 'Chatea Ahora',
    contactSupport: 'Comuníquese con el soporte',
    emergencyMessage:
      'Si cree que usted o un miembro de su familia está teniendo una emergencia médica o psiquiátrica, llame al 911. No intente acceder a la atención de emergencia a través de esta aplicación.',
    header: '¿Con quién te gustaría chatear?',
    joinQueue: 'Unirse a la cola',
    logOut: 'Cerrar sesión',
    noChatsBody:
      'No hemos podido encontrar ningún plan del tipo especificado asociado a tu cuenta. Elige una de las siguientes opciones para continuar:',
    noChatsFound: 'No se ha encontrado ningún chat',
    serviceClosed: 'Servicio Cerrado',
    viewAllPlans: 'Ver todos los planes',
  },
  closeMenu: 'Cerrar menú',
  closeModal: 'Cerrar modal',
  confirmLeaveApp:
    'Está a punto de salir de la aplicación para usar nuestra función de Cuidado local',
  continue: 'Continuar',
  contrasts: {
    decrease: 'Disminuir el contraste',
    increase: 'Aumentar contraste',
  },
  copy: 'copiar',
  createDependentDialog: {
    addDependent: 'Agregar un dependiente menor',
    checkboxCopy:
      'Al marcar esta casilla y continuar, confirmo que soy el padre o tutor legal de %{firstName} %{lastName} nacido %{dob} y estoy autorizado a recibir su información de salud.',
    dependentHeader: 'Información del dependiente menor:',
    fillInfo:
      'Rellene la información siguiente para que pueda recibir atención para su dependiente menor. Solo se pueden agregar niños menores de %{age}.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    letsAddDependent: '¡Añadamos un dependiente menor de edad!',
  },
  createPassword: 'Crear Contraseña',
  dateOfBirth: 'Fecha de cumpleaños',
  dateParts: {
    day: 'Día',
    month: 'Mes',
    year: 'Año',
  },
  dependent: 'dependiente',
  dependentCard: {
    display: '%{gender} | %{age} Ańos',
  },
  edit: 'Editar',
  edited: 'Editado',
  email: 'Correo electrónico',
  encountersPage: {
    enterName: 'Ingrese el apellido de un paciente para buscar.',
    noEncountersFound: 'No se encontraron encuentros.',
    noPatientsFound: 'No se encontraron pacientes',
  },
  enterChat: 'Entrar al Chat',
  exitQueue: 'Salir de la Cola',
  exitQueueDialog: {
    confirmation: '¿Esta Seguro?',
    endSession: 'Finalizar Sesión',
    exitDisclaimer:
      'Al salir de la cola, perderá su lugar en la fila y finalizará su sesión.',
    stayInQueue: 'Permanecer en la cola',
  },
  familySettings: 'Configuración familiar',
  faq: 'Haga clic aquí para ver las preguntas frecuentes',
  fileBrowser: {
    unsupportedFormat:
      'Formato de imagen no admitido. Aceptamos los siguientes formatos: JPG, PNG, GIF, Bitmap. Le pedimos que utilice su mejor criterio al cargar imágenes digitales. Si es menor de 18 años, consulte a un padre o tutor antes de cargar cualquier foto que pueda ser cuestionable.',
    uploadImage: 'Cargar imagen',
  },
  fontSizes: {
    bigger: 'Más grande',
    biggest: 'El mas grande',
    default: 'Defecto',
    increaseFontSize: 'Aumenta el tamaño de la fuente',
  },
  forgotPasswordPage: {
    emailInstructions:
      'Comprueba tu correo electrónico y sigue las instrucciones para restablecer tu contraseña.',
    emailSentNotice: '¡Te hemos enviado un correo electrónico!',
    formDescription:
      'Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un correo electrónico con instrucciones sobre cómo registrar tu cuenta.',
    header: '¿Ha olvidado su contraseña?',
    nowWhat: '¿Ahora qué?',
    pageTitle: 'Olvidado Contraseña',
    spamLinkText: 'prueba con otro correo electrónico.',
    spamNotice:
      '¿No ves ningún correo electrónico? Revisa tus carpetas de correo basura y spam o',
  },
  formElementHelpers: {
    charsRemaining: '%{num} caracteres restantes',
  },
  formPlaceholders: {
    email: 'nombre@ejemplo.com',
  },
  fullScreenControls: {
    enterFullscreen: 'Ingrese a pantalla completa',
    exitFullscreen: 'Salir de pantalla completa',
  },
  gender: 'Género',
  genderIdentity: 'Identidad de género',
  genderIdentities: {
    female: 'Femenino',
    genderFluid: 'Género fluido',
    genderNonConforming: 'Género no conforme',
    intersex: 'Intersexual',
    male: 'Masculino',
    nonBinary: 'No binario',
    other: 'Algo más',
    transgender: 'Transgénero',
    twoSpirit: 'Dos Espíritus',
    somethingElse: 'Algo más',
    noDisclose: 'Prefiero no decirlo',
    unknown: 'No conocida',
  },
  getStarted: 'Empezar',
  healthInsuranceProvider: 'Proveedor de Seguro Médico',
  heightOption: '%{totalInches} pulgadas (%{feet}\' %{inches}")',
  helloWorld: 'Hola Mundo',
  hi: 'Hola',
  hidePassword: 'Ocultar contraseña',
  isTyping: 'esta escribiendo...',
  locationInquiry: '¿En qué estado se encuentra actualmente?',
  medicalInfoCard: {
    allergiesLabel: 'Alergias / Sensibilidades a los Medicamentos',
    clickToEdit: 'Haga clic en el texto para editar',
    historyLabel: 'Condiciones / Historial Médico',
    pleaseReview: 'Revise y confirme su información médica.',
    prescriptionLabel: 'Recetas y medicamentos',
  },
  messageFailedToSend: 'No se pudo enviar el mensaje',
  messageInput: {
    channelDeactivated: 'Este canal ha sido desactivado para este paciente.',
    sendMessage: 'Enviar mensaje',
    typeMessage: 'Escribir mensaje',
    typeMessageFor: 'Escribir mensaje para %{name}',
  },
  minorDependent: 'Dependiente menor',
  my: 'Mis',
  name: 'Nombre',
  needInvitation: '¿Necesitas una invitación?',
  needInvitationLink:
    '¿Necesitas una invitación? <a href="/invitation/resend">Envía una solicitud.</a>',
  newPassword: 'Nueva contraseña',
  newPasswordConfirmation: 'Confirmación de contraseña nueva',
  notificationLinkMessages: {
    abandonGoal: {
      success: 'Meta abandonada',
    },
    genericError:
      'Ocurrió un error y no se pudieron guardar los cambios. Inténtalo de nuevo.',
    somethingWentWrong: 'Algo salió mal',
    success: '¡Éxito!',
    patientStream: {
      networkError:
        'No se pueden encontrar secuencias de mensajes: actualice la página o comuníquese con el soporte',
    },
    updateDependentProfile: {
      success: 'Miembro de la familia guardado',
    },
    updatePatientProfile: {
      error: 'No se pudo actualizar el perfil',
      success: 'Se actualizó el perfil',
    },
    updateAccount: {
      success: {
        email: 'Correo electrónico guardado',
        password: 'Contraseña guardada',
      },
    },
    completeEncounter: {
      success: 'Nota de progreso creada',
    },
    completeGoal: {
      success: 'Se completó el objetivo',
    },
    createDependent: {
      success: '¡Su dependiente menor fue agregado a su cuenta!',
    },
    createGoal: {
      success: 'Se creó el objetivo',
    },
    createGoalNote: {
      success: 'Se creó la nota de objetivo.',
    },
    createReminder: {
      success: 'Se creó el recordatorio',
    },
    deleteMessage: {
      networkError: 'No se puede eliminar el mensaje; comuníquese con soporte',
    },
    deleteReminder: {
      networkError:
        'No se puede eliminar el recordatorio; comuníquese con soporte',
      success: 'Recordatorio eliminado',
    },
    deleteStandardPhrase: {
      networkError: 'No se puede eliminar la frase; comuníquese con soporte',
      success: 'Frase eliminada',
    },
    dismissEncounter: {
      networkError:
        'No se puede descartar el encuentro; comuníquese con soporte',
    },
    publishPatientNote: {
      error: 'Error al publicar nota',
      success: 'Enviado a CPRS',
    },
    recordPatientMeasurement: {
      error: 'No se puede registrar la medición; comuníquese con soporte',
    },
    shareLabOrderToStream: {
      error:
        'No se puede compartir la orden de laboratorio; comuníquese con soporte',
      success:
        'Imágenes de resultados de laboratorio compartidas con el paciente',
    },
    transferEncounter: {
      success: 'Transferencia exitosa',
    },
    updateGoal: {
      success: 'Objetivo actualizado',
    },
    updatePatient: {
      error: 'No se puede actualizar el perfil del paciente',
      success: 'Perfil del paciente actualizado',
    },
    updateProgressNote: {
      success: 'Nota de progreso actualizada',
    },
    updateProviderProfile: {
      error: 'No se pudo actualizar el perfil',
      success: 'Se actualizó el perfil',
    },
    updateReminder: {
      success: 'Recordatorio actualizado',
    },
  },
  notVerified: 'No verificado',
  pagination: {
    back: 'Atrás',
    next: 'Siguiente',
  },
  password: 'Contraseña',
  passwordConfirmation: 'Confirmación de contraseña',
  passwordRules:
    '<div style="text-align:left;width:100%"><b>Reglas de contraseña:</b></div><ul style="text-align:left;margin-block-end:0;margin-block-start:8px"><li>Al menos 8 caracteres.</li><li>Al menos 1 número. </li><li>Tanto en mayúsculas como en minúsculas. </li><li>Al menos 1 símbolo (p. ej. ! # ?)</li></ul>',
  patient: 'El paciente',
  patientLocation: {
    accountSettings: 'Configuraciones de la cuenta.',
    description:
      'Su ubicación actual nos ayuda a conectarlo con los proveedores y recursos adecuados.',
    dependentDescription:
      'Usted y su menor dependiente deben estar en el mismo lugar.',
    displayNameDescription:
      'Por defecto usamos su nombre legal, pero puede cambiar su nombre preferido en su ',
    readyForVisit: '¿Listo para una visita?',
    readyForVisitConfirm: '¿Listo para una visita? Confirme su ubicación.',
  },
  patientCostAndQualityPage: {
    pageTitle: 'Cuidado local',
    startChat: {
      cta: 'Comenzar chat',
      text: 'Conéctese con un médico certificado en 60 segundos o menos.',
    },
  },
  patientGoalsPage: {
    pageTitle: 'Metas',
    status: {
      completed: 'Completado',
      in_progress: 'Activo',
      initiated: 'Próximamente',
    },
    zeroState: 'Actualmente no tienes ningún objetivo %{status}.',
    zeroStateDependent:
      '%{name} actualmente no tiene ningún objetivo %{status}.',
  },
  patientLabOrdersPage: {
    ordered: 'Ordenado %{date}',
    orderedBy: 'Ordenado por %{name}',
    orders: 'Órdenes',
    pageTitle: 'Órdenes de laboratorio',
    received: 'Recibido %{date}',
    results: 'Resultados',
    status: {
      lab_orders: 'Laboratorios Ordenados',
      lab_results: 'Resultados de Laboratorio',
    },
    viewOrders: 'Ver pedido',
    viewResults: 'Ver resultados',
    zeroState: {
      lab_orders: 'No se encontraron pedidos de laboratorio',
      lab_results: 'No se encontraron resultados de laboratorio',
    },
  },
  patientSettingsPage: {
    accessibilityHeader: 'Soporte de accesibilidad',
    audioNotificationHeader: 'Notificaciones de Audio',
    insurance: 'Seguro',
    leadInHeader: 'Eres el jefe de tu cuenta, personaliza tu experiencia aquí.',
    medical: 'Médico',
    myAccount: 'Mi Cuenta',
    myFamily: 'Mi Familia',
    playSound: 'Reproducir un sonido audible cuando llegue un mensaje nuevo',
    preferences: 'Preferencias',
    preferredLanguageHeader: 'Idioma preferido',
    revokeConsentDescription:
      'Actualice su consentimiento de SSO ajustando el interruptor para actualizar instantáneamente sus preferencias. Si aún no ha hecho clic en el botón SSO asociado con el interruptor, el interruptor se desactivará. Una vez que haya hecho clic en el botón SSO y haya hecho clic en "sí" para dar su consentimiento, se habilitará la opción. Si cambia de opinión, simplemente deslice el interruptor hacia "apagar". Puede restablecer fácilmente su consentimiento en cualquier momento deslizando el interruptor hacia "activado".',
    revokeConsentHeader:
      'Administre rápidamente cómo accede a los servicios con SSO',
    revokeCostAndQualitySsoConsentLabel: 'Cuidado local',
  },
  pcp: 'Médico de atención primaria (PCP)',
  pending: 'Pendiente ...',
  pleaseSelectOption: 'Por favor seleccione una opción',
  phone: 'Teléfono',
  preChatPage: {
    body: 'Seleccione el chat que mejor se adapte a sus necesidades.',
    createAccountDisclaimer: 'Los adultos necesitan crear su propia cuenta.',
    selectChat: 'Seleccione un chat.',
    selectProfile: 'Seleccione un perfil.',
    welcome: 'Bienvenidos',
  },
  preferredLanguage: 'Idioma preferido',
  preferredLanguageDialog: {
    autoTranslateDisclaimer:
      'Está a punto de habilitar la traducción automática para traducir entre español e inglés.',
    disableDisclaimer:
      'Puede desactivar la traducción automática en cualquier momento en la pestaña de configuración o en la barra de navegación.',
    header: '¿Quieres cambiar de idioma?',
    reloadDisclaimer: 'Al confirmar su página se recargará.',
    rttDisclaimer:
      'Podrá utilizar traducciones en tiempo real para mensajes de chat y notas de progreso en su idioma preferido.',
    staticTextDisclaimer:
      'Todo el contenido estático se traducirá al idioma seleccionado.',
    thirdPartyDisclaimer:
      'Debido a las limitaciones de la tecnología de terceros, pueden producirse errores de traducción. Puede desactivar las traducciones automáticas en cualquier momento en la configuración.',
  },
  preScreen: {
    hello: '¡Hola!',
    providerHelp: 'Informe a nuestros proveedores cómo pueden ayudar.',
    startChat:
      'Simplemente inicie su chat con un saludo y, si lo desea, incluya un motivo para conversar hoy.',
  },
  primary: 'Primario',
  printForPcp: 'Imprimir para proveedor de atención primaria',
  privacyLink:
    'nuestra <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Política de privacidad</a>',
  privacyPolicy: 'Política de privacidad',
  profileMenu: 'Menú de perfil',
  pronouns: 'Pronombres',
  provider: 'El proveedor',
  providerInfoPanel: {
    about: 'Acerca de su proveedor',
    meet: 'Conocer a',
  },
  providerVerifyPhone: {
    buttonText: 'Verificar mi número de teléfono',
    header: 'Se requiere verificación de número de teléfono',
    helperText:
      'Como parte de nuestro compromiso continuo con la seguridad de la información, hemos actualizado nuestro sistema de notificación por SMS. La actualización requerirá que proporcione y verifique su número de teléfono para continuar recibiendo notificaciones por SMS.',
  },
  registrationPage: {
    dobInvalid: 'La fecha de nacimiento no es válida',
    invalidFormInfo:
      'El formulario contiene información inválida. Resuelva los problemas y vuelva a intentarlo.',
    pageTitle: 'Registro',
    welcome:
      '¡Bienvenido! Estamos encantados de tenerte aquí. Por favor, rellene el siguiente formulario para iniciar el proceso de registro.',
  },
  raceEthnicities: {
    americanIndian: 'Amerindia o Nativo de Alaska ',
    asian: 'Asiático',
    africanAmerican: 'Negro o Afroamericano',
    hispanic: 'Origen Hispano, Latino o Español',
    middleEastern: 'Medio Oriente o África del Norte',
    hawaiian: 'Nativo de Hawái o de Otra Isla del Pacífico',
    white: 'Blanco',
    multiEthnic: 'Multiétnico',
    noAnswer: 'Prefiero no responder',
    somethingElse: 'Algo más',
  },
  registerInvitationPage: {
    agree: {
      toFinancialResponsibility:
        'Acepto el <a href="%{href}" rel="noreferrer nofollow noopener "target="_blank">Acuerdo de responsabilidad financiera del paciente</a>',
      toInformedConsent:
        'Estoy de acuerdo con el <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Consentimiento Informado del Paciente</a>',
      toInformedConsentAndPrivacyPractices:
        'Acepto el <a href="%{consentHref}" rel="noreferrer nofollow noopener" target="_blank">Consentimiento informado del paciente</a> y el <a href="%{noticeHref}" rel="noreferrer nofollow noopener" target="_blank">Aviso de prácticas de privacidad</a>',
      toPrivacyPolicy:
        'Acepto la <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Política de privacidad</a>',
      toPrivacyPractices:
        'Acepto el <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Aviso de Prácticas de Privacidad</a>',
      toSmsMarketing:
        '<b>Opcional:</b> Al marcar esta casilla, acepto CirrusMD SMS Marketing <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Términos y condiciones</a> y autorizo a CirrusMD a comunicarse conmigo al número de teléfono proporcionado a través de mi membresía o perfil a través de un mensaje de texto SMS utilizando tecnología de marcación automática con fines de marketing y/o publicidad. Entiendo que no tengo que dar mi consentimiento a CirrusMD y que se pueden aplicar tarifas de mensajes y datos. La frecuencia de los mensajes varía. Envía AYUDA para obtener ayuda. Para optar por no participar o revocar el consentimiento, responda STOP a cualquier mensaje de texto SMS.',
      toTermsLabel: 'He leído y acepto los términos y condiciones',
      toTermsOfUse:
        'Estoy de acuerdo con los <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Términos de uso</a>',
      toTermsOfUseAndPrivacyPolicy:
        'Acepto los <a href="%{termsHref}" rel="noreferrer nofollow noopener" target="_blank">Términos de uso</a> y <a href="%{privacyHref}" rel="noreferrer nofollow noopener" target="_blank">Política de privacidad</a>',
      youAgreePrefix: 'Al registrarse, acepta',
    },
    pageDescription:
      'Su privacidad y consentimiento son importantes para nosotros. Seleccione cada casilla para indicar que está de acuerdo.',
    pageHeader: 'Términos y Acuerdos',
    pageTitle: 'Completar su registro',
    submitLabel: 'Registro',
  },
  requiredFieldsExplanation:
    'Se requieren campos marcados con un asterisco (*)',
  resend: 'Reenviar',
  resendInvitationPage: {
    formDescription:
      'Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un correo electrónico con instrucciones sobre cómo registrar tu cuenta.',
    pageTitle: 'Reenvía tu invitación',
  },
  revealPassword: 'Revelar contraseña',
  save: 'Ahorrar',
  saved: 'Salvado',
  search: 'Buscar',
  select: 'Seleccione',
  selectState: 'Seleccionar estado',
  send: 'Enviar',
  sendInstructions: 'Enviar Instrucciones',
  sendRequest: 'Envía una solicitud.',
  settings: 'Ajustes',
  settingsDependent: {
    description:
      'Sus dependientes menores son parte de su cuenta; chatear en nombre de ellos no requiere inicios de sesión adicionales ni pasos complicados. Simplemente cambie de perfil y comience a chatear con un proveedor.',
    title: 'Manejar la salud de su familia nunca ha sido tan fácil',
  },
  settingsMyAccount: {
    accountDetails: 'Detalles de la cuenta',
    demographicDescription:
      'Ayúdenos a garantizar que nuestra plataforma brinde una atención equitativa. Sus respuestas son opcionales y no se mostrarán a su proveedor.',
    keepProfileUpdated:
      'Mantenga actualizada la información de su perfil para que podamos brindarle la mejor atención.',
    legalFirstName: 'Primer nombre legal',
    legalLastName: 'Apellido legal',
    moreInfo: 'Más Información',
    preferredFirstName: 'Nombre preferido',
    profile: 'Perfil',
    race: 'Raza/Etnia',
    selectGenderIdentity: 'Seleccione una identidad de género...',
    selectRace: 'Seleccione una raza / etnia ...',
    selectSex: 'Seleccione un sexo...',
    sexAssignedAtBirth: 'Sexo Asignado al nacer',
  },
  shareFeedback: 'Compartir comentarios',
  sidebarHeader: '%{name} servicios de salud',
  signIn: 'Iniciar Sesión',
  signInPage: {
    agreeText: 'Al iniciar sesión, aceptas',
    forgotPasswordLink:
      '<a href="/password/new">¿Has olvidado tu contraseña?</a>',
    header: 'Ingrese a su cuenta',
    registerLink:
      '¿No tienes una cuenta?<a href="%{registerHref}">Inscribirse</a>',
    welcomeBack:
      '¡Bienvenido de nuevo! Inicie sesión con la información que ingresó durante el registro.',
  },
  signOut: 'Desconectar',
  skip: 'Saltar',
  specialties: 'Especialidades',
  status: 'Estatus',
  stickyFooter: {
    needSupport: '¿Necesita Soporte Técnico?',
    reportConcern: '¿Informar una inquietud sobre la atención médica?',
  },
  streamMessages: {
    exitAssessment:
      '¿Está seguro de que desea salir de esta evaluación? Su progreso se perderá si cierra este modal.',
    printDocNote:
      'Parte de este mensaje se tradujo automáticamente. Por favor revise su correo electrónico para imprimir la nota de su médico.',
    videoSessionExpired:
      'La sesión de video ha expirado. El proveedor deberá iniciar una nueva sesión de video.',
  },
  streamMessageTitles: {
    closed: 'Cerrado',
    nonBillableNote: 'Nota de documentación clínica',
    patientEndedChat: 'Chat finalizado por el paciente',
    progressNote: 'Nota de progreso',
    questionsSummary: '%{identifier} Resumen de preguntas',
    transferred: 'Transferido',
  },
  submit: 'Enviar',
  submitFeedback: 'Enviar comentarios',
  surveys: {
    close: 'Cerca',
    excellent: 'Excelente',
    good: 'Bueno',
    modalCloseTitle: 'Cerrar mensaje de agradecimiento de la encuesta',
    needsImprovement: 'Necesita Mejorar',
    negative: 'Experiencia negativa',
    okay: 'Okey',
    poor: 'Pobre',
    positive: 'Experiencia positiva',
  },
  termsAndAgreements: {
    agreeToFinancialResponsibility:
      'Acepto el <a href="%{url}" rel="noreferrer nofollow noopener "target="_blank">Acuerdo de responsabilidad financiera del paciente</a>',
    agreeToInformedConsent:
      'Estoy de acuerdo con el <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Consentimiento Informado del Paciente</a>',
    agreeToPrivacyPolicy:
      'Acepto la <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Política de privacidad</a>',
    agreeToPrivacyPractices:
      'Acepto el <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Aviso de Prácticas de Privacidad</a>',
    agreeToTerms:
      'Estoy de acuerdo con los <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Términos de uso</a>',
    agreeToTextMessageMarketingAgreement:
      '<b>Opcional:</b> Al marcar esta casilla, acepto CirrusMD SMS Marketing <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Términos y condiciones</a> y autorizo a CirrusMD a comunicarse conmigo al número de teléfono proporcionado a través de mi membresía o perfil a través de un mensaje de texto SMS utilizando tecnología de marcación automática con fines de marketing y/o publicidad. Entiendo que no tengo que dar mi consentimiento a CirrusMD y que se pueden aplicar tarifas de mensajes y datos. La frecuencia de los mensajes varía. Envía AYUDA para obtener ayuda. Para optar por no participar o revocar el consentimiento, responda STOP a cualquier mensaje de texto SMS.',
    heading: 'Términos y Acuerdos',
  },
  termsAndPrivacyLink:
    'nuestros <a href="%{termsHref}" rel="noreferrer nofollow noopener" target="_blank">Términos de uso</a> y <a href="%{privacyHref}" rel="noreferrer nofollow noopener" target="_blank">Política de privacidad</a>',
  termsAndPrivacyPolicy: {
    informedConsent: 'Consentimiento informado',
    noticeOfPrivacy: 'Aviso de prácticas de privacidad',
    patientFinancial: 'Acuerdo de responsabilidad financiera del paciente',
  },
  termsLink:
    'nuestros <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Términos de Uso</a>',
  termsOfUse: 'Términos de Uso',
  translatedByText: 'Proporcionado mediante traducción automática',
  unsupportedBrowser:
    'Está utilizando un navegador no compatible, utilice la última versión de escritorio de Chrome, Firefox o Edge.',
  updateDependentDialog: {
    addProfileImage: 'Agregar imagen de perfil',
    editFamilyMember: 'Editar miembro de la familia',
  },
  uploads: {
    imageDescription: 'Descripción de la imagen',
    imageFormatDisclaimer:
      'Aceptamos los siguientes formatos: JPG, PNG, GIF, Bitmap. Le pedimos que utilice su mejor criterio al cargar imágenes digitales. Si es menor de 18 años, consulte a un padre o tutor antes de cargar cualquier foto que pueda ser cuestionable.',
    instructions: 'Instrucciones de carga',
    upload: 'Cargar',
    uploadPhoto: 'Cargar foto',
  },
  validations: {
    exactLength: 'Debe tener %{numChars} caracteres',
    minLength: 'Debe tener al menos %{numChars} caracteres',
    required: 'Este campo es obligatorio',
  },
  verify: 'Verificar',
  verifyHealthInsurance: 'Verificar el Seguro Médico',
  verifyInsurance: 'Verificar el seguro',
  verifySubscriberIdDialog: {
    bannerText:
      'Estamos verificando sus beneficios, esto puede demorar hasta un minuto.',
    description:
      'Antes de iniciar un chat, tendrás que confirmar tu cuenta ingresando tu',
    errorText: 'Seguro de salud no verificado',
    havingTrouble: '¿Teniendo problemas? Póngase en contacto con el soporte en',
    idCardSuffix: 'se pueden encontrar en su tarjeta de seguro médico',
    verifyWarning:
      'No cierre ni actualice este modal mientras verificamos su información.',
  },
  videoSession: {
    accessDenied:
      '¡Uy! Se ha bloqueado el acceso a la cámara y al micrófono. Concede el acceso en la configuración de tu navegador.',
    connectingText: 'Conectarse a una sesión de vídeo.',
    endTitle: 'Final',
    leavePageConfirmation: '¿Estás seguro de que quieres salir de esta página?',
    patientVideoUnavailable: 'Vídeo inhabilitado.',
    providerVideoUnavailable: 'El video del proveedor no está disponible.',
    sessionEnded: '%{actor} ha finalizado la sesión de video.',
    waitingToConnect: 'Esperando a que %{actor} se conecte.',
  },
  websocketBanner: {
    healthInsuranceVerified: '¡Tu seguro de salud ha sido verificado!',
    newVersion: 'Una nueva versión de la página está disponible.',
    reloadPage: 'Recargar página',
    reconnectingIn: 'Reconectando en %{seconds} segundos.',
    reconnectNow: 'Reconectar ahora',
    reconnectingNow: 'Reconectando ahora...',
  },
  welcomeMessage: {
    helperText:
      '¡Estás listo para iniciar un chat o explorar! Confirmaremos algunos detalles y te ayudaremos a llegar al lugar correcto.',
    subtitle: 'Nos alegra que estés aquí.',
  },
  your: 'Tu',
  zipCode: 'Código Postal',
}

export default LANGUAGE_MAPPING
